import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import arrowRight from '../../../../../assets/images/icons/arrow/chevron-right-black.svg';

export const useStyles = makeStyles(({
  fontFamilies,
  palette,
  lineHeights,
  fontSizes,
  fontWeights,
}: Theme) => ({
  shopList: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
  },
  shopItem: {
    fontFamily: fontFamilies.primary,
    fontSize: fontSizes.sm,
    lineHeight: lineHeights.md,
    borderBottom: `1px solid ${palette.grey['200']}`,
    background: `no-repeat url(${arrowRight}) center right`,
    backgroundSize: '0.625rem auto',
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    padding: '2rem 0',
    color: palette.common.black,
    textDecoration: 'none',
    fontWeight: fontWeights.medium,
  },
}));
